module.exports = __webpack_public_path__ + "static/media/screenshot-8.35762de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-8.png
// module id = 693
// module chunks = 2